export interface TaxesTrackingModel {
	name: string;
	location?: ToastLocation;
}

enum ToastLocation {
	Prompts = "crypto declaration prompt",
	Confirmation = "crypto taxes confirmation",
	Screen = "crypto taxes screen",
	Options = "crypto declaration options screen",
	History = "transaction history",
	Declaration = "crypto declaration screen",
	Swap = "crypto declaration swap screen",
	TrxDetail = "transaction detail view"
}

const COMMON_EVENTS = {
	DATE_AND_INVESTMENT: "Date And Initial Investment Button Clicked",
	BOUGHT_BEFORE: "Bought Before March 2021 Button Clicked",
	PRICE_UNKNOWN: "I Don't Know The Date Or Price Button Clicked",
	BACK_NAVIGATION: "Back Navigation Button Clicked",
	DEPOSIT_INFO: "Deposit Info Section Clicked"
};

export const TAXES_SCREEN_VIEW: TaxesTrackingModel = {
	name: "Crypto Taxes Screen Viewed"
};

export const TAXES_DO_IT_LATER: TaxesTrackingModel = {
	name: "Do It Later Button Clicked",
	location: ToastLocation.Prompts
};

export const TAXES_LEARN_MORE: TaxesTrackingModel = {
	name: "Learn More Button Clicked",
	location: ToastLocation.Prompts
};

export const OPTION_DATE_INITIAL_INVESTMENT: TaxesTrackingModel = {
	name: COMMON_EVENTS.DATE_AND_INVESTMENT,
	location: ToastLocation.Options
};

export const OPTION_TAXES_BOUGHT_BEFORE: TaxesTrackingModel = {
	name: COMMON_EVENTS.BOUGHT_BEFORE,
	location: ToastLocation.Options
};

export const OPTION_TAXES_PRICE_UNKNOWN: TaxesTrackingModel = {
	name: COMMON_EVENTS.PRICE_UNKNOWN,
	location: ToastLocation.Options
};

export const TAXES_BOUGHT_BEFORE: TaxesTrackingModel = {
	name: COMMON_EVENTS.BOUGHT_BEFORE,
	location: ToastLocation.Screen
};

export const TAXES_PRICE_UNKNOWN: TaxesTrackingModel = {
	name: COMMON_EVENTS.PRICE_UNKNOWN,
	location: ToastLocation.Screen
};

export const TAXES_SUCCESS_TOAST: TaxesTrackingModel = {
	name: "Crypto Declaration Success Toast Displayed",
	location: ToastLocation.Confirmation
};

export const TAXES_ALL_CHECKBOX: TaxesTrackingModel = {
	name: "All Checkbox Selected",
	location: ToastLocation.Screen
};

export const TAXES_CONFIRMATION_BUTTON: TaxesTrackingModel = {
	name: "This Is Correct Button Clicked",
	location: ToastLocation.Confirmation
};

export const TAXES_DEPOSIT_BUTTON_HISTORY: TaxesTrackingModel = {
	name: "See Deposits Button Clicked",
	location: ToastLocation.History
};

export const TAXES_DECLARATION_BACK_BUTTON: TaxesTrackingModel = {
	name: COMMON_EVENTS.BACK_NAVIGATION,
	location: ToastLocation.Declaration
};

export const TAXES_DECLARATION_DEPOSIT_INFO: TaxesTrackingModel = {
	name: COMMON_EVENTS.DEPOSIT_INFO,
	location: ToastLocation.Declaration
};

export const TAXES_DECLARATION_DATE_BUTTON: TaxesTrackingModel = {
	name: "Date Button Clicked",
	location: ToastLocation.Declaration
};

export const TAXES_DECLARATION_DATE_RANGE_BUTTON: TaxesTrackingModel = {
	name: "Date Range Button Clicked",
	location: ToastLocation.Declaration
};

export const TAXES_SWAP_SCREEN_VIEWED: TaxesTrackingModel = {
	name: "Crypto Declaration Swap Screen Viewed"
};

export const TAXES_SWAP_BACK_BUTTON: TaxesTrackingModel = {
	name: COMMON_EVENTS.BACK_NAVIGATION,
	location: ToastLocation.Swap
};

export const TAXES_SWAP_OPTION_NO: TaxesTrackingModel = {
	name: "No Option Selected",
	location: ToastLocation.Swap
};

export const TAXES_SWAP_OPTION_YES: TaxesTrackingModel = {
	name: "Yes Option Selected",
	location: ToastLocation.Swap
};

export const TAXES_CONFIRMATION_BACK_BUTTON: TaxesTrackingModel = {
	name: COMMON_EVENTS.BACK_NAVIGATION,
	location: ToastLocation.Confirmation
};

export const TAXES_MAX_BUTTON: TaxesTrackingModel = {
	name: "Max Button Clicked",
	location: ToastLocation.Declaration
};

export const TAXES_DATE_SELECTED: TaxesTrackingModel = {
	name: "Date And Initial Investment Option Selected Clicked",
	location: ToastLocation.Declaration
};

export const TAXES_BOUGHT_BEFORE_SELECTED: TaxesTrackingModel = {
	name: "Bought Before March 2021 Option Selected Clicked",
	location: ToastLocation.Declaration
};

export const TAXES_DONT_KNOW_PRICE_SELECTED: TaxesTrackingModel = {
	name: "I Dont Know The Date Or Price Option Selected",
	location: ToastLocation.Declaration
};

export const TAXES_LEAVE_PROCESS: TaxesTrackingModel = {
	name: "Leave Declaration Process Confirmation Screen Viewed"
};

export const TAXES_SUCCESS_VIEW: TaxesTrackingModel = {
	name: "Crypto Declaration Success Screen Viewed"
};

export const TAXES_TRX_DETAIL_VIEWED: TaxesTrackingModel = {
	name: "Tax Info Section Viewed",
	location: ToastLocation.TrxDetail
};

export const TAXES_TRX_DETAIL_PROMPT_CLICKED: TaxesTrackingModel = {
	name: "Crypto Declaration Share Now Button Clicked",
	location: ToastLocation.TrxDetail
};
